import { motion } from 'motion/react';
import { useInView } from "react-intersection-observer";

const MotionDiv = ({ children }) => {
    const [ref, inView] = useInView({
        threshold: 0.1,     // Hur mycket av elementet måste vara synligt
        triggerOnce: true,  // Tona bara in en gång, inte ut igen när man scrollar förbi
    });

    return (
        <motion.div
            ref={ref}
            initial={{ opacity: 0, y: 24 }}
            animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 24 }}
            transition={{ duration: 0.7, ease: "easeOut" }}
        >
            {children}
        </motion.div>
    );
};

export default MotionDiv;
